import React from 'react';
import './NoAdminPermissions.scss';

const NoAdminPermissions = ({ userEmail }) => {
	const email = 'support@thalo.app';
	return (
		<div className="NoAdminPermissionsContainer">
			<div className="noAdminPermissionsDiv">
				<h1>Welcome to Thālo!</h1>
				<div className={'noContentMessage'}>
					{`You (${userEmail}) are currently not connected to any clients. 
						If you believe you should have access to a client workspace, 
						please email: `}
					<a href={`mailto:${email}`}>{email}</a>
				</div>
			</div>
		</div>
	);
};

export default NoAdminPermissions;
